import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

interface Props {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { authState } = useOktaAuth();
  const location = useLocation();

  if (!authState) {
    return (
      <div className="min-h-screen bg-cargo-bg flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-cargo-accent animate-spin" />
      </div>
    );
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
